// Port of api/fuel/app/classes/insights/shelf/activity.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'
import Config from 'offline/model/config'
import DB from 'offline/db'

function parseIndex(value) {
	if (!value) return []
	if (typeof value === 'string' && value.charCodeAt(0) === 91 /* '[' */) {
		try {
			var parsed = JSON.parse(value)
			if (Array.isArray(parsed)) {
				var out = new Array(parsed.length)
				var n = 0
				for (var i = 0; i < parsed.length; i++) {
					var v = parsed[i] | 0
					if (v) out[n++] = v
				}
				out.length = n
				return out
			}
		} catch (e) {}
	}
	// Fast CSV parser for "1,2,3,..." — avoid String.split() + map(parseInt)
	// which allocate two intermediate arrays and call parseInt per element.
	var s = String(value)
	var len = s.length
	var result = []
	var num = 0
	var hasDigit = false
	for (var p = 0; p < len; p++) {
		var c = s.charCodeAt(p)
		if (c === 44 /* , */) {
			if (hasDigit && num) result.push(num)
			num = 0
			hasDigit = false
		} else if (c >= 48 && c <= 57) {
			num = num * 10 + (c - 48)
			hasDigit = true
		}
	}
	if (hasDigit && num) result.push(num)
	return result
}

function monthStart(timestamp) {
	var d = new Date(timestamp * 1000)
	d.setUTCDate(1)
	d.setUTCHours(0, 0, 0, 0)
	return Math.floor(d.getTime() / 1000)
}

function monthEnd(timestamp) {
	var d = new Date(timestamp * 1000)
	d.setUTCMonth(d.getUTCMonth() + 1, 0)
	d.setUTCHours(23, 59, 59, 0)
	return Math.floor(d.getTime() / 1000)
}

function excludedGameIds(userId) {
	var config = Config.user(userId)
	var unplayed = (config.lists && config.lists.unplayed) ? config.lists.unplayed : {}
	var exclude = Array.isArray(unplayed.games) ? unplayed.games.slice() : []

	if (!unplayed.trade) {
		var tradeRows = Util.queryFast(
			'SELECT game_id FROM collection WHERE collection_fortrade = 1 AND user_id = ' + userId
		)
		for (var i = 0; i < tradeRows.length; i++) exclude.push(parseInt(tradeRows[i].game_id, 10))
	}

	if (!unplayed.rated) {
		var ratedRows = Util.queryFast(
			'SELECT game_id FROM collection WHERE collection_rating > 0 AND user_id = ' + userId
		)
		for (var j = 0; j < ratedRows.length; j++) exclude.push(parseInt(ratedRows[j].game_id, 10))
	}

	return exclude.filter(Boolean)
}

export default Segment.extend({
	name: 'activity',
	priority: 5,
	insight: false,
	detail: false,
	run: function(type, owner) {
		var ownerId = owner.get_id()
		var activity = []
		var exclude = excludedGameIds(ownerId)
		var excludeSet = {}
		for (var ex = 0; ex < exclude.length; ex++) excludeSet[exclude[ex]] = true

		// Use queryFast for the three large SELECTs in this segment.
		var insights = Util.queryFast(
			'SELECT insight_date, insight_stamp, insight_games, insight_added, insight_count_base' +
			' FROM insight_user_collection WHERE user_id = ' + ownerId + ' ORDER BY insight_date ASC'
		)

		// Cache MIN(play_date) per game as a number, not a Util.query indexed
		// hash of objects. We never need any other field of firstPlays in the
		// hot loop below.
		var firstPlayRows = Util.queryFast(
			'SELECT MIN(p.play_date) AS d, p.game_id AS g FROM play p' +
			' WHERE p.user_id = ' + ownerId + ' GROUP BY p.game_id'
		)
		var firstPlayDate = {}
		for (var fr = 0; fr < firstPlayRows.length; fr++) {
			firstPlayDate[firstPlayRows[fr].g] = firstPlayRows[fr].d || 0
		}

		var baseGameRows = Util.queryFast('SELECT game_id FROM game WHERE game_type = 1')
		var baseGameSet = {}
		for (var bg = 0; bg < baseGameRows.length; bg++) baseGameSet[baseGameRows[bg].game_id] = true

		// Bucket the user's logs by month-start once, up front. The hot path
		// per insight then does a single hash lookup instead of an inner SQL
		// call.
		var logRows = Util.queryFast(
			'SELECT l.log_date AS d, l.log_context AS c, l.game_id AS g' +
			' FROM log_user_collection l' +
			' WHERE l.user_id = ' + ownerId +
			' ORDER BY l.log_date ASC, l.log_context ASC'
		)
		var logsByMonth = {}
		for (var lr = 0; lr < logRows.length; lr++) {
			var rawDate = logRows[lr].d
			if (!rawDate) continue
			var key = monthStart(rawDate)
			if (!logsByMonth[key]) logsByMonth[key] = []
			logsByMonth[key].push(logRows[lr])
		}

		var LOG_ADDED = Constants.LOG_CONTEXT_ADDED
		var LOG_REMOVED = Constants.LOG_CONTEXT_REMOVED

		for (var i = 0; i < insights.length; i++) {
			var insight = insights[i]
			var insightDate = insight.insight_date | 0
			var monthStartTs = monthStart(insightDate)
			var monthEndTs = monthEnd(insightDate)
			var gameIndex = parseIndex(insight.insight_games)
			var gameIndexLen = gameIndex.length
			var addedThisMonth = parseIndex(insight.insight_added)
			var addedThisMonthSet = {}
			for (var ai = 0; ai < addedThisMonth.length; ai++) addedThisMonthSet[addedThisMonth[ai]] = true

			// Inline counting + index building. Use plain integer counters
			// for added/removed/played (we only return the count); only
			// shelfIndex needs to remain an array because it's exposed in
			// the response.
			var shelfIndex = []
			var addedSeen = {}
			var addedCount = 0
			var removedSeen = {}
			var removedCount = 0
			var playedSeen = {}
			var playedCount = 0

			for (var g = 0; g < gameIndexLen; g++) {
				var gameId = gameIndex[g]
				if (!baseGameSet[gameId]) continue
				if (excludeSet[gameId]) continue

				var fpDate = firstPlayDate[gameId]
				if (fpDate) {
					if (fpDate > monthEndTs) {
						shelfIndex.push(gameId)
					} else if (fpDate > monthStartTs && !addedThisMonthSet[gameId]) {
						if (!playedSeen[gameId]) { playedSeen[gameId] = true; playedCount++ }
					}
				} else {
					shelfIndex.push(gameId)
				}
			}

			var logs = logsByMonth[monthStartTs]
			if (logs) {
				for (var li = 0; li < logs.length; li++) {
					var log = logs[li]
					var logGame = log.g
					if (excludeSet[logGame]) continue
					if (!baseGameSet[logGame]) continue

					var fpd = firstPlayDate[logGame] || 0
					var logDate = log.d
					if (logDate < monthStartTs || logDate > monthEndTs) continue

					var ctx = log.c | 0
					if (ctx === LOG_ADDED) {
						if (fpd) {
							if (fpd > logDate) {
								if (!addedSeen[logGame]) { addedSeen[logGame] = true; addedCount++ }
								if (fpd < monthEndTs) {
									if (!playedSeen[logGame]) { playedSeen[logGame] = true; playedCount++ }
								}
							}
						} else {
							if (!addedSeen[logGame]) { addedSeen[logGame] = true; addedCount++ }
						}
					} else if (ctx === LOG_REMOVED) {
						if (fpd) {
							if (fpd > logDate) {
								if (!removedSeen[logGame]) { removedSeen[logGame] = true; removedCount++ }
							} else if (fpd > monthStartTs) {
								if (!playedSeen[logGame]) { playedSeen[logGame] = true; playedCount++ }
							}
						} else {
							if (!removedSeen[logGame]) { removedSeen[logGame] = true; removedCount++ }
						}
					}
				}
			}

			var insightCountBase = insight.insight_count_base | 0

			activity.push({
				month: insight.insight_stamp,
				unix: insightDate,
				size: shelfIndex.length,
				percent: insightCountBase ? (100 / insightCountBase) * shelfIndex.length : 0,
				index: shelfIndex,
				added: addedCount,
				removed: removedCount,
				played: playedCount
			})
		}

		this._data.activity = activity

		if (activity.length > 12) activity = activity.slice(activity.length - 12)

		return {
			activity: activity
		}
	}
})
